import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CancelIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8.0402 1.3335C4.35354 1.3335 1.37354 4.3135 1.37354 8.00016C1.37354 11.6868 4.35354 14.6668 8.0402 14.6668C11.7269 14.6668 14.7069 11.6868 14.7069 8.00016C14.7069 4.3135 11.7269 1.3335 8.0402 1.3335ZM8.0402 13.3335C5.1002 13.3335 2.70687 10.9402 2.70687 8.00016C2.70687 5.06016 5.1002 2.66683 8.0402 2.66683C10.9802 2.66683 13.3735 5.06016 13.3735 8.00016C13.3735 10.9402 10.9802 13.3335 8.0402 13.3335ZM10.4335 4.66683L8.0402 7.06016L5.64687 4.66683L4.70687 5.60683L7.1002 8.00016L4.70687 10.3935L5.64687 11.3335L8.0402 8.94016L10.4335 11.3335L11.3735 10.3935L8.9802 8.00016L11.3735 5.60683L10.4335 4.66683Z" />
  </Icon>
);

export default memo(CancelIcon);
